define('modules/form_editor/models/custom_email',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "custom:email",
    isSocialBindable: true,
    defaultValues: {
      "placeholder": "",
      "variable": "",
      "socialBinding": ""
    },
    defaultErrorMsgKey: "formEditor.validationMessages.email",
  });
});

